"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _api["default"];
  }
});
var _api = _interopRequireDefault(require("./api"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }